/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { getEntities as getDiagLabPanels } from 'app/entities/diag-lab-panel/diag-lab-panel.reducer';
import { getEntities as getLabTestItems } from 'app/entities/lab-test-item/lab-test-item.reducer';
import { getEntities as getImageTests } from 'app/entities/image-tests/image-tests.reducer';
import { createEntity, getEntity, reset, updateEntity } from './diaglab-test-threshold.reducer';

export const DiaglabTestThresholdUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const diagLabPanels = useAppSelector(state => state.diagLabPanel.entities);
  const labTestItems = useAppSelector(state => state.labTestItem.entities);
  const imageTests = useAppSelector(state => state.imageTests.entities);
  const diaglabTestThresholdEntity = useAppSelector(state => state.diaglabTestThreshold.entity);
  const loading = useAppSelector(state => state.diaglabTestThreshold.loading);
  const updating = useAppSelector(state => state.diaglabTestThreshold.updating);
  const updateSuccess = useAppSelector(state => state.diaglabTestThreshold.updateSuccess);

  const handleClose = () => {
    navigate(`/diaglab-test-threshold${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDiagLabs({}));
    dispatch(getDiagLabPanels({}));
    dispatch(getLabTestItems({}));
    dispatch(getImageTests({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.threshold !== undefined && typeof values.threshold !== 'number') {
      values.threshold = Number(values.threshold);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...diaglabTestThresholdEntity,
      ...values,
      diagLab: diagLabs.find(it => it.id.toString() === values.diagLab?.toString()),
      panel: diagLabPanels.find(it => it.id.toString() === values.panel?.toString()),
      testItem: labTestItems.find(it => it.id.toString() === values.testItem?.toString()),
      radiologyTest: imageTests.find(it => it.id.toString() === values.radiologyTest?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...diaglabTestThresholdEntity,
          diagLab: diaglabTestThresholdEntity?.diagLab?.id,
          panel: diaglabTestThresholdEntity?.panel?.id,
          testItem: diaglabTestThresholdEntity?.testItem?.id,
          radiologyTest: diaglabTestThresholdEntity?.radiologyTest?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.diaglabTestThreshold.home.createOrEditLabel" data-cy="DiaglabTestThresholdCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.diaglabTestThreshold.home.createOrEditLabel">
              Create or edit a DiaglabTestThreshold
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="diaglab-test-threshold-id"
                  label={translate('tinyMedicRestApp.diaglabTestThreshold.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabTestThreshold.sourceStatusCode')}
                id="diaglab-test-threshold-sourceStatusCode"
                name="sourceStatusCode"
                data-cy="sourceStatusCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabTestThreshold.targetStatusCode')}
                id="diaglab-test-threshold-targetStatusCode"
                name="targetStatusCode"
                data-cy="targetStatusCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabTestThreshold.threshold')}
                id="diaglab-test-threshold-threshold"
                name="threshold"
                data-cy="threshold"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabTestThreshold.active')}
                id="diaglab-test-threshold-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabTestThreshold.cursor')}
                id="diaglab-test-threshold-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabTestThreshold.lastUpdated')}
                id="diaglab-test-threshold-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabTestThreshold.microSec')}
                id="diaglab-test-threshold-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabTestThreshold.timestampEntry')}
                id="diaglab-test-threshold-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="diaglab-test-threshold-diagLab"
                name="diagLab"
                data-cy="diagLab"
                label={translate('tinyMedicRestApp.diaglabTestThreshold.diagLab')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diaglab-test-threshold-panel"
                name="panel"
                data-cy="panel"
                label={translate('tinyMedicRestApp.diaglabTestThreshold.panel')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabPanels
                  ? diagLabPanels.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diaglab-test-threshold-testItem"
                name="testItem"
                data-cy="testItem"
                label={translate('tinyMedicRestApp.diaglabTestThreshold.testItem')}
                type="select"
              >
                <option value="" key="0" />
                {labTestItems
                  ? labTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diaglab-test-threshold-radiologyTest"
                name="radiologyTest"
                data-cy="radiologyTest"
                label={translate('tinyMedicRestApp.diaglabTestThreshold.radiologyTest')}
                type="select"
              >
                <option value="" key="0" />
                {imageTests
                  ? imageTests.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/diaglab-test-threshold" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DiaglabTestThresholdUpdate;
